module.exports = __webpack_public_path__ + "media/images/right-arrow-black-cfb757de.svg";